import React from 'react';
import { string } from 'prop-types';
import { BeginnerDifficulty } from './difficulty/Beginner';
import { IntermediateDifficulty } from './difficulty/Intermediate';
import { AdvancedDifficulty } from './difficulty/Advanced';
import { UnderTwoHours } from './time/underTwoHours';
import { TwoToFourHours } from './time/twoToFourHours';
import { OverOneDay } from './time/overOneDay';

export function SVGComponent({ name }) {
  const mappings = {
    beginner: BeginnerDifficulty,
    intermediate: IntermediateDifficulty,
    advanced: AdvancedDifficulty,
    'under-2-hours': UnderTwoHours,
    '2-4-hours': TwoToFourHours,
    'over-1-day': OverOneDay
  };

  const Component = mappings[name] || null;

  return Component && <Component />;
}

SVGComponent.propTypes = {
  name: string.isRequired,
};
